module.exports = __webpack_public_path__ + "img/landscape_2-lazy.c0571eba.jpg";